export enum CEMImportTypes {
  WellMassUpdate = 0,
  DrillingForecastDetail = 1,
  CompletionsForecastDetail = 2,
  WellConnectForecastDetail = 3,
  FlowlineForecastDetail = 4,
  PipelineForecastDetail = 5,
  TankBatteryForecastDetail = 6,
  PadConstructionForecastDetail = 7
}